/** Shape used to derive how many free items to auto-add from a BOGOF suggestion. */
export type BogofSuggestionForFreeCount = {
  free_products_count_to_add?: number | null;
  free_products?: Array<{ id: string; shop_id: string }> | null;
  /** Promotion cap on free units; used when count exceeds template rows for a single SKU. */
  free_quantity?: number | null;
};

function countDistinctFreeProductIds(
  freeProducts: Array<{ id: string }> | null | undefined,
): number {
  if (!freeProducts?.length) {
    return 0;
  }
  return new Set(freeProducts.map(p => p.id)).size;
}

/**
 * Returns how many free units of the BOGOF gift SKU to add for kiosk auto-add flow.
 * Exported for unit tests; business rules evolve independently of the effect.
 */
export function nonComposableProductFreeBogofProductToAdd(
  suggestion: BogofSuggestionForFreeCount,
): number {
  const freeProducts = suggestion.free_products ?? [];
  const distinctIds = countDistinctFreeProductIds(freeProducts);

  if (distinctIds > 1) {
    return 1;
  }

  if (distinctIds === 1) {
    return suggestion.free_products_count_to_add ?? 1;
  }

  return 1; // should not appen
}
